import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {gqlPayment} from '../getPayment.api';
import {Payment} from '../../../graphql/payments.datatypes';
import {CreateGroupMemberPayment} from './createPayment.api';

export interface UpdateGroupMemberPayment {
    id: number
    group_member_id: number
    amount: number
}

export interface UpdatePaymentInput {
    data: {
        id: number
        billing_party_member_id?: number
        amount?: number
        billing_party_amount?: number
        timestamp?: string
        payment_type?: number
        payment_status?: number
        provider_reference?: string | null
        provider_status?: string
        provider_response_raw?: string
        reconciled?: boolean
        description?: string
        refunds_amount?: number
        cc_fee?: number | null

        groupMembers?: {
            connect?: number[]
            disconnect?: number[]
        }

        groupMemberPayments?: {
            create?: CreateGroupMemberPayment[]
            update?: UpdateGroupMemberPayment[]
            delete?: number[]
        }
    }
}

interface UpdatePaymentData {
    __typename?: string,
    updatePayment: Payment
}

export const UPDATE_PAYMENT_MUTATION = gql`
    mutation updatePayment($data: UpdatePaymentInput!) {
        updatePayment(data: $data) {
            ${gqlPayment}
        }
    }
`;

export const updatePayment = () => useMutation<UpdatePaymentData, UpdatePaymentInput>(
    UPDATE_PAYMENT_MUTATION,
    {
        update: updateCacheByType('Payment'),
    }
);

export default updatePayment;
